import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { QuoteBoardItem } from "~/shared/schemas/quote-board-schema";

import { CopyQuoteButton } from "./copy-quote-button.tsx";

type CopyQuoteCellProps = Omit<GridCustomCellProps, "dataItem"> & {
	dataItem: QuoteBoardItem;
	isDisabled?: boolean;
};

export const CopyQuoteCell = (props: CopyQuoteCellProps) => {
	const dataItem = props.dataItem as QuoteBoardItem | undefined;

	// Guard against undefined dataItem
	if (!dataItem) {
		return <GridTd tdProps={props.tdProps} />;
	}

	return (
		<GridTd tdProps={props.tdProps}>
			{props.isDisabled ? null : <CopyQuoteButton quoteId={dataItem.quoteId} />}
		</GridTd>
	);
};
